/**
 * Fixed vs flexible anchoring — same grammar as hard vs soft dependencies.
 * Hard things constrain the engine; soft things are what the engine may bend.
 */

export type PlacementAnchoring = 'fixed' | 'flexible';

/** @deprecated Prefer PlacementAnchoring — alias kept for existing call sites. */
export type LaunchFlexibility = PlacementAnchoring;

export const ANCHORING_LABEL: Record<PlacementAnchoring, string> = {
  fixed: 'Fixed (hard)',
  flexible: 'Flexible (soft)',
};

export const ANCHORING_HELP: Record<PlacementAnchoring, string> = {
  fixed:
    'Hard constraint — the engine will not move this date. Conflicts report infeasibility instead of sliding.',
  flexible:
    'Soft constraint — the engine may slide this window when absorbing conflicts or capacity pressure.',
};

/** Parse `flexibility:fixed|flexible` or `anchoring:fixed|flexible` from priority notes. */
export function parseAnchoringFromNotes(notes?: string | null): PlacementAnchoring | null {
  if (!notes) return null;
  const m = /(?:anchoring|flexibility)\s*:\s*(fixed|flexible)/i.exec(notes);
  if (!m) return null;
  return m[1].toLowerCase() as PlacementAnchoring;
}

/** Upsert anchoring tag in notes without wiping other note content. */
export function upsertAnchoringInNotes(
  notes: string | null | undefined,
  anchoring: PlacementAnchoring,
): string {
  const base = (notes ?? '').replace(/(?:^|\s)(?:anchoring|flexibility)\s*:\s*(fixed|flexible)\b/gi, '').trim();
  const tag = `anchoring:${anchoring}`;
  return base ? `${base}; ${tag}` : tag;
}

export function resolveAnchoring(
  explicit: PlacementAnchoring | null | undefined,
  suggested: PlacementAnchoring,
): PlacementAnchoring {
  return explicit ?? suggested;
}
